import { connect } from "react-redux";
import merge from "lodash/merge";
import React from "react";

import * as actions from "../actions/actions";
let Loading = require("./loading");

class FortIconDetail extends React.Component {
    addTags(e) {
        let newIcon = merge({}, this.state.icon);

        newIcon.tags = e.target.value;

        this.setState({
            icon: newIcon
        });
    }

    addTitle(e) {
        let newIcon = merge({}, this.state.icon);

        newIcon.term = e.target.value;

        this.setState({
            icon: newIcon
        });
    }

    componentWillReceiveProps(nextProps) {
        let icon = nextProps.icon;

        if (Array.isArray(icon.tags)) {
            icon.tags = icon.tags
                .map(function(tag) {
                    return tag.slug;
                })
                .join(", ");
        }

        this.setState({
            icon: icon
        });
    }

    constructor(props) {
        super(props);

        this.props.fetchFortIcon(this.props.iconId);

        this.state = {
            icon: this.props.icon
        };
    }

    disableIcon(e) {
        e.preventDefault();

        if (this.props.icon.is_active === "1") {
            this.props.disableIcon(this.props.icon);
        }
    }

    featureIcon(e) {
        e.preventDefault();
        if (this.props.icon.featured_icon) {
            this.props.unFeatureIcon("icon", this.props.icon.id);
        } else {
            this.props.featureIcon("icon", this.props.icon.id);
        }
    }

    render() {
        let attributionImg,
            twelveHundedPNG,
            collectionTitle,
            collectionInfo,
            moderatorTitle,
            moderatorInfo;

        if (this.props.icon) {
            if (this.props.icon.attribution_preview_url) {
                attributionImg = (
                    <figure>
                        <img
                            className="icon_image"
                            width="100%"
                            style={{ maxWidth: "300px" }}
                            src={this.props.icon.attribution_preview_url}
                        />
                        <figcaption>With Attribution</figcaption>
                    </figure>
                );
            }

            if (this.props.icon.preview_url_1200) {
                twelveHundedPNG = (
                    <figure>
                        <img
                            className="icon_image"
                            width="100%"
                            style={{ maxWidth: "300px" }}
                            src={this.props.icon.preview_url_1200}
                        />
                        <figcaption>1200px png</figcaption>
                    </figure>
                );
            }

            if (this.props.icon.collections[0]) {
                collectionTitle = (
                    <tr>
                        <td>
                            <a href={this.props.icon.collections[0].permalink}>
                                Collection
                            </a>{" "}
                            (<a
                                href={`/fort/collections/${
                                    this.props.icon.collections[0].id
                                }/`}
                            >
                                fort
                            </a>)
                        </td>
                        <td>
                            <input
                                type="text"
                                readOnly
                                value={this.props.icon.collections[0].slug}
                            />
                        </td>
                    </tr>
                );
                collectionInfo = (
                    <tr
                        className={
                            this.props.icon.collections[0].is_featured === "1"
                                ? "dot-true"
                                : "dot-false"
                        }
                    >
                        <td>Collection Featured</td>
                        <td>
                            <div>
                                {this.props.icon.collections[0].is_featured ===
                                "1"
                                    ? "True"
                                    : "False"}
                            </div>
                        </td>
                    </tr>
                );
            } else {
                collectionTitle = (
                    <tr>
                        <td>Collection</td>
                        <td>—</td>
                    </tr>
                );
            }

            if (this.props.icon.moderator) {
                moderatorTitle = (
                    <tr>
                        <td>Moderated</td>
                        <td>
                            <div>
                                {this.props.icon.moderator.moderation_date}
                                ago
                                <span>
                                    {this.props.icon.moderator.moderation_date}
                                </span>
                            </div>
                        </td>
                    </tr>
                );
                moderatorInfo = (
                    <tr>
                        <td>
                            <a href={this.props.icon.moderator.permalink}>
                                Moderator
                            </a>
                        </td>
                        <td>
                            <div>
                                {this.props.icon.moderator.name}
                                <span>
                                    {this.props.icon.moderator.username}
                                    (
                                    {this.props.icon.moderator.id}
                                    )
                                </span>
                            </div>
                        </td>
                    </tr>
                );
            }

            return (
                <div className="container">
                    <section id="icon-info" className="clearfix">
                        <div className="container">
                            <div className="six columns">
                                {twelveHundedPNG}
                                <figure className="margin-t-xl">
                                    <img
                                        className="icon_image"
                                        width="100%"
                                        style={{ maxWidth: "300px" }}
                                        src={this.props.icon.icon_url}
                                    />
                                    <figcaption>Original SVG</figcaption>
                                </figure>

                                <div className="display-flex margin-t-xl margin-b-xl">
                                    {attributionImg}
                                    <figure>
                                        <img
                                            className="icon_image"
                                            width="200"
                                            height="200"
                                            src={this.props.icon.preview_url}
                                        />
                                        <figcaption>200px</figcaption>
                                    </figure>
                                    <figure>
                                        <img
                                            className="icon_image"
                                            width="84"
                                            height="84"
                                            src={this.props.icon.preview_url_84}
                                        />
                                        <figcaption>84px</figcaption>
                                    </figure>
                                    <figure>
                                        <img
                                            className="icon_image"
                                            width="42"
                                            height="42"
                                            src={this.props.icon.preview_url_42}
                                        />
                                        <figcaption>42px</figcaption>
                                    </figure>
                                </div>
                                <a
                                    href="#"
                                    className="ui_rastor button full-width regenerate-icon-assets"
                                    onClick={this.regenerateIcon.bind(this)}
                                >
                                    <span>Regenerate Assets</span>
                                </a>
                            </div>

                            <div className="six columns">
                                <form
                                    id="icon-edit-form"
                                    className="admin-form margin-t-xl margin-b-xl"
                                    action={`/icon/edit/${this.props.icon.id}/`}
                                    data-id={this.props.icon.id}
                                >
                                    <ol>
                                        <li>
                                            <button
                                                id="feature_icon"
                                                className={`
                                                    button
                                                    ${
                                                        this.props.icon
                                                            .featured_icon
                                                            ? "gray"
                                                            : "yellow"
                                                    }
                                                    full-width
                                                `}
                                                onClick={this.featureIcon.bind(
                                                    this
                                                )}
                                            >
                                                <span>
                                                    {this.props.icon
                                                        .featured_icon
                                                        ? "Unfeature Icon"
                                                        : "Feature Icon"}
                                                </span>
                                            </button>
                                        </li>
                                        <li>
                                            <label htmlFor="primary-term">
                                                Primary Term
                                            </label>
                                            <input
                                                id="primary-term"
                                                value={this.state.icon.term}
                                                name="term"
                                                onChange={this.addTitle.bind(
                                                    this
                                                )}
                                            />
                                        </li>
                                        <li>
                                            <label htmlFor="icon-tags">
                                                Tags in comma seperated list
                                            </label>
                                            <textarea
                                                id="icon-tags"
                                                placeholder="ex: tag, another-tag, tagged, final-tag"
                                                value={this.state.icon.tags}
                                                onChange={this.addTags.bind(
                                                    this
                                                )}
                                            />
                                        </li>
                                        <li>
                                            <button
                                                type="submit"
                                                className="button ui_save button-process full-width"
                                                onClick={this.saveIconDetails.bind(
                                                    this
                                                )}
                                            >
                                                <span>Save Details</span>
                                            </button>
                                        </li>
                                    </ol>
                                </form>
                                <div className="admin-table">
                                    <table>
                                        <tbody>
                                            <tr
                                                className={
                                                    this.props.icon.is_active ==
                                                    "1"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Active</td>
                                                <td className="is_active">
                                                    <div>
                                                        {this.props.icon
                                                            .is_active == "1"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>ID</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            this.props.icon.id
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Term ID</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            this.props.icon
                                                                .term_id
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={
                                                            this.props.icon
                                                                .permalink
                                                        }
                                                    >
                                                        Permalink
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            this.props.icon
                                                                .permalink
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Tags</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            this.state.icon.tags
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={`/fort/members/${
                                                            this.props.icon
                                                                .uploader_id
                                                        }/`}
                                                    >
                                                        Uploader
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            this.props.icon
                                                                .uploader
                                                                .username
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Uploader Email</td>
                                                <td>
                                                    *not available through API
                                                    yet*
                                                </td>
                                            </tr>
                                            {collectionTitle}
                                            {collectionInfo}
                                            <tr>
                                                <td>Attribution</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            this.props.icon
                                                                .attribution
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>License</td>
                                                <td>
                                                    <div>
                                                        {
                                                            this.props.icon
                                                                .license_description
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Uploaded</td>
                                                <td>
                                                    <div>
                                                        {
                                                            this.props.icon
                                                                .date_uploaded
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                            {moderatorTitle}
                                            {moderatorInfo}
                                            <tr
                                                className={
                                                    this.props.icon
                                                        .is_explicit == "1"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Explicit</td>
                                                <td className="is_explicit">
                                                    <div>
                                                        {this.props.icon
                                                            .is_explicit == "1"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    this.props.icon
                                                        .nounji_free == "1"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Nounji Free</td>
                                                <td className="nounji_free">
                                                    <div>
                                                        {this.props.icon
                                                            .nounji_free == "1"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    this.props.icon.sponsor_id
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Sponsor ID</td>
                                                <td>
                                                    <div>
                                                        {this.props.icon
                                                            .sponsor_id
                                                            ? this.props.icon
                                                                  .sponsor_id
                                                            : "Not Sponsored"}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="kinda-danger-zone">
                                <button
                                    id="disable_icon"
                                    className={`
                                        button ui_broken-heart red
                                        ${
                                            this.props.icon.is_active == "0"
                                                ? "disabled"
                                                : ""
                                        }
                                    `}
                                    data-id={this.props.icon.id}
                                    onClick={this.disableIcon.bind(this)}
                                >
                                    <span>
                                        {this.props.icon.is_active == "1"
                                            ? "Disable Icon"
                                            : "Icon is disabled"}
                                    </span>
                                </button>

                                <p>
                                    Once you push this button, it is not easy to
                                    un-do. God speed.
                                </p>
                            </div>
                        </div>
                    </section>
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    regenerateIcon(e) {
        e.preventDefault();
        this.props.regenerateIcon(this.props.icon);
    }

    saveIconDetails(e) {
        e.preventDefault();
        this.props.saveFortIconInfo(this.state.icon);
    }
}

function mapStateToProps(state, ownProps) {
    let icon;

    if (state.icons.keys) {
        state.icons.keys.forEach(iconId => {
            if (iconId === ownProps.iconId) {
                icon = state.icons[iconId];
                if (Array.isArray(icon.tags)) {
                    icon.tags.shift(); //remove term which is first tag
                }
            }
        });
    }
    return { icon };
}

module.exports = connect(mapStateToProps, {
    disableIcon: actions.disableIcon,
    featureIcon: actions.featureIcon,
    fetchFortIcon: actions.fetchFortIcon,
    regenerateIcon: actions.regenerateIcon,
    saveFortIconInfo: actions.saveFortIconInfo,
    unFeatureIcon: actions.unFeatureIcon
})(FortIconDetail);
